import React from 'react'
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const DialogConcurso = ({ toggleFunction, modalState }) => {
  const navLinks = [
    {
      name: "Especialidades y Maestrías",
      path: "/concurso"
    },
    {
      name: "Doctorados",
      path: "/concurso/doctorados"
    }
  ]

  return (
    <Modal 
      show={modalState} 
      onHide={() => toggleFunction(false)} 
      dialogClassName='custom-sm' 
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Concurso 2026</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-center'>
          <div className='d-flex flex-column gap-3'>
            { navLinks.map((link) => (
              <Link key={link.name} className='btn btn-primary link-button' to={link.path}>
                {link.name}
              </Link>
            ))}
          </div>
        </section>
      </Modal.Body>
    </Modal>
  )
}

export { DialogConcurso }